import {useAppSelector} from "./customReduxHooks";
import {selectAuthUserData} from "../store/auth";

export const useUserCheck = () => {
    const authUserData = useAppSelector(selectAuthUserData);
    return (userId: string) => {
        return userId === authUserData.userId;
    }
}